import Link from 'next/link';
import { useRouter } from 'next/router';
import { chainflipLinks } from '@chainflip/utils/consts';
import Message from '@/shared/components/molecules/Message';
import useLocalStorage from '@/shared/hooks/useLocalStorage';
import { useLpBalancesAndAddresses } from '@/shared/hooks/useLpStats';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import PlusCircleIcon from '@/shared/icons/flip-ui-kit/large/PlusCircle';
import { useStateChainAccount } from '../hooks/useStateChainAccount';

const disableMessage = true;

export const Banners = ({ isMobileView = false }: { isMobileView?: boolean }) => {
  const { selectedAccount, selectAccount } = usePolkadot();
  const [displayMessage, setDisplayMessage] = useLocalStorage(
    'displayBoostSplitMessage',
    (value) => (typeof value === 'boolean' ? value : true),
  );

  const { pathname } = useRouter();
  const isBalancesSection = pathname.startsWith('/balances');

  const { liquidityDataLoading, hasLiquidity } = useLpBalancesAndAddresses(selectedAccount?.idSs58);
  const { account, accountInfo } = useStateChainAccount();

  const showEmptyBalanceBanner =
    !isMobileView &&
    selectedAccount &&
    !selectedAccount.readonly &&
    !liquidityDataLoading &&
    accountInfo !== null &&
    !hasLiquidity;

  return (
    <>
      {isMobileView ? (
        <div className="flex w-full items-center justify-center bg-cf-blue-1/20 p-[5px] font-aeonikMedium text-14 text-cf-blue-2">
          You are in view-only mode.
        </div>
      ) : (
        selectedAccount?.readonly && (
          <div className="flex w-full items-center justify-center bg-cf-pink-1/20 p-2 text-14 text-cf-pink-1">
            You are in view-only mode.&nbsp;
            <button type="button" className="underline" onClick={() => selectAccount(null)}>
              Sign up now
            </button>
            &nbsp;to start earning fees!
          </div>
        )
      )}
      {!selectedAccount?.readonly && displayMessage && !disableMessage && (
        <Message
          message={
            <span>
              {`We have removed the 5 bps fee for limit orders. Please ensure you account for this when placing new orders. Read more about 1.9 release`}{' '}
              <Link
                className="underline"
                target="_blank"
                href={new URL(
                  '/v1-9-the-next-wave-of-improvements',
                  chainflipLinks.blog,
                ).toString()}
              >
                here
              </Link>
            </span>
          }
          variant="success"
          onClose={() => setDisplayMessage(false)}
        />
      )}
      {showEmptyBalanceBanner && (
        <div className="flex w-full items-center justify-center gap-x-1 bg-cf-blue-1/20 p-[5px] font-aeonikMedium text-14 text-cf-blue-2">
          <PlusCircleIcon />
          {account
            ? 'Your account balance is empty. Make a deposit to start earning, borrowing or providing liquidity.'
            : 'Your account balance is empty. Make your first deposit to complete your account setup.'}
          {!isBalancesSection && (
            <Link className="underline" href="/balances">
              Deposit now.
            </Link>
          )}
        </div>
      )}
    </>
  );
};
